import useTranslator from "../../hooks/useTranslator";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import Slider from "rc-slider";
import Tooltip from "rc-tooltip";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import "react-circular-progressbar/dist/styles.css";
import "react-circular-progressbar/dist/styles.css";
import VectorIcon from "../../assets/img/VectorIcon1.svg";
import moreInfoimg from "../../assets/img/moreInfoimg.svg";
import Twotone from "../../assets/img/ic_twotone-euro.svg";
import Twotone2 from "../../assets/img/ic_twotone-euro2.svg";
import UserIcon from "../../assets/img/user-icon-gray.svg";
import { useEffect, useState } from "react";
import { haveValue } from "../../helper/common";
import moment from "moment";
import TotalSalaryModal from "./TotalSalaryModal";
import UpdatedIncomeSourceModal from "./UpdateIncomeSourceModal";
import BellIcon from "../../assets/img/bell-icon.svg";

const DetailsSkor = (props) => {
  const {
    user = {},
    combinedIncome = 0,
    effortObj,
    handleRentPercSave = () => {},
    userIncome = {},
    gurantorsIncome = {},
    handleIncomeChange,
    totalIncomeModal,
    setTotalIncomeModal,
    showReportIcons,
  } = props;
  const { _t } = useTranslator();
  const [scoreValue, setScoreValue] = useState(null);
  const [updateIncomeSourceModal, setUpdateIncomeSourceModal] = useState(false);
  const maxValue = 1000;
  const [value, setValue] = useState(0);
  const [ieScore, setIeScore] = useState(null);
  const [updateSourceObj, setUpdateSourceObj] = useState({
    _id: "",
    all_sources: {},
    current_selected: "",
  });
  useEffect(() => {
    if (haveValue(scoreValue) && haveValue(maxValue))
      setValue((scoreValue / maxValue) * 100);
  }, [scoreValue]);

  useEffect(() => {
    if (!haveValue(ieScore) && user?.ie_verified && user?.is_university) {
      calculateIeScore();
    }
    const temp_score =
      user?.ie_verified && user?.is_university
        ? ieScore
        : user?.paymentScores?.creditScore?.value;
    if (haveValue(temp_score)) {
      setScoreValue(temp_score);
    }
  }, [user, ieScore]);

  const calculateIeScore = () => {
    var totalScore = (user?.paymentScores?.creditScore?.value || 0) / 2;

    if (user?.ie_verified && user?.is_university) {
      if (totalScore >= 600) {
        totalScore += 200;
      } else {
        totalScore += 400;
      }
    }
    if (totalScore > 850) {
      totalScore = 850;
    }
    setIeScore(totalScore);
  };

  const getProgressColor = (percentage) => {
    if (percentage < 20) return "#F3483E";
    if (percentage < 40) return "#F77841";
    if (percentage < 60) return "#F8E002";
    if (percentage < 80) return "#99DE04";
    return "#05C200";
  };

  const Handle = Slider.Handle;
  const handle = (props) => {
    const { value, dragging, index, ...restProps } = props;
    console.log(props);
    return (
      <Tooltip
        prefixCls="rc-slider-tooltip"
        overlay={value}
        visible={dragging}
        placement="top"
        key={index}
      >
        <Handle value={value} {...restProps} />
        <img src={Twotone} alt="Vector Icon" className="vactorImg" />
      </Tooltip>
    );
  };

  const returnSkorStatus = () => {
    const skor =
      user?.ie_verified && user?.is_university
        ? ieScore
        : user?.paymentScores?.creditScore?.value;
    if (skor <= 200) {
      return <h2 className="UnstableText">{_t("unstable")}</h2>;
    } else if (skor >= 201 && skor <= 400) {
      return <h2 className="VariableText">{_t("variable")}</h2>;
    } else if (skor >= 401 && skor <= 600) {
      return <h2 className="StableText">{_t("stable")}</h2>;
    } else if (skor >= 601 && skor <= 800) {
      return <h2 className="ReliableText">{_t("reliable")}</h2>;
    } else if (skor >= 800) {
      return <h2 className="ExtremelyText">{_t("extremelyReliable")}</h2>;
    }
  };

  const [efforRateLocal, setEfforRateLocal] = useState(10);

  useEffect(() => {
    setEfforRateLocal(effortObj?.effort_rate ?? 10);
  }, [effortObj, user]);

  const handleChangeEffortRate = (e) => {
    setEfforRateLocal(e);
  };

  const handleChangeEffortRateApiCall = (e) => {
    console.log(e);
    handleRentPercSave(e);
  };
  const min = 10;
  const max = 50;
  const left = efforRateLocal;
  const percent = ((efforRateLocal - min) / (max - min)) * 100; // 50 - 10 / 50 - 10 * 100

  return (
    <>
      <div className="row">
        <div className="col-6">
          <div className="Profile_summary2 skorsetbox p-3">
            <h4>{_t("setEffortRate")}</h4>
            <div>
              <div className="skormeter vw-mt-4 w-100 position-relative">
                <Slider
                  min={10}
                  max={50}
                  defaultValue={efforRateLocal}
                  value={efforRateLocal}
                  handle={handle}
                  onChangeComplete={handleChangeEffortRateApiCall}
                  onChange={handleChangeEffortRate}
                  draggableTrack={true}
                />
                <div className="slider-labels">
                  <span>10%</span>
                  <span>20%</span>
                  <span>30%</span>
                  <span>40%</span>
                  <span>50%</span>
                </div>
                <div
                  style={{
                    left: `calc(${percent}%)`,
                    transform: "translateX(-50%)",
                  }}
                  className="default-check-modal-percentage modal-percentage percentage-profile"
                >
                  {left}%
                </div>
                <div className="amountset">
                  <span>€{Math.round((combinedIncome ?? 0) * 0.1)}</span>
                  <span>€{Math.round((combinedIncome ?? 0) * 0.2)}</span>
                  <span>€{Math.round((combinedIncome ?? 0) * 0.3)}</span>
                  <span>€{Math.round((combinedIncome ?? 0) * 0.4)}</span>
                  <span>€{Math.round((combinedIncome ?? 0) * 0.5)}</span>
                </div>
              </div>
            </div>
            <div className="row vw-mt-4">
              <div className="col-6">
                <div className="col incomeDiv incomeDiv2 d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-between align-items-end w-100">
                    <div className="d-flex justify-content-between align-items-center income_info_card">
                      <div className="Twotone_img d-flex align-items-center justify-content-center">
                        <img
                          src={Twotone2}
                          alt="Vector Icon"
                          className="TwotoneIcon"
                        />
                      </div>
                      <div>
                        <p className="Profileheading_change3">
                          €{combinedIncome}
                        </p>
                        <p className="Profileheading_change">
                          {_t("combinedIncome")}
                        </p>
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-center gap-1 cursor-pointer"
                      onClick={() => setTotalIncomeModal(true)}
                    >
                      <img
                        src={UserIcon}
                        alt="Vector Icon"
                        className="vactorImg vactorImg1"
                      />
                      <p className="length-text">
                        {+(user?.gurantor_id?.length ?? 0) + 1}
                      </p>
                      <img
                        className="Imagerutate ImageSizeSet"
                        src={VectorIcon}
                        alt="Vector Icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="col incomeDiv incomeDiv2 d-flex justify-content-between align-items-center">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex justify-content-between align-items-center income_info_card">
                      <div className="Twotone_img d-flex align-items-center justify-content-center">
                        <img
                          src={"/images/max-rent-icon.svg"}
                          alt="Vector Icon"
                          className="TwotoneIcon"
                        />
                      </div>
                      <div className="profile_heading_width">
                        <p className="Profileheading_change3">
                          €{effortObj?.effort_amount}
                        </p>
                        <p className="Profileheading_change">
                          {_t("maxRentBasedOnEffortRateOf")}
                          {efforRateLocal}%
                        </p>
                      </div>
                    </div>
                    {/* <div className="d-flex align-items-center gap-1">
                      <img
                        src={moreInfoimg}
                        alt="Vector Icon"
                        className="vactorImg vactorImg1"
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-6">
          {haveValue(scoreValue) ? (
            <div className="Profile_summary2 skorsetbox p-3">
              <h4 className="text-end">{_t("financialSkor")}</h4>
              <div className="row">
                <div className="col-6">
                  <div style={{ position: "relative" }}>
                    {/* SVG Gradient (hidden but used via URL) */}
                    <svg
                      style={{ height: "0", position: "absolute", top: "0" }}
                    >
                      <defs>
                        <linearGradient
                          id="progressGradient"
                          x1="0%"
                          y1="0%"
                          x2="100%"
                          y2="0%"
                        >
                          <stop
                            offset="100%"
                            stopColor={getProgressColor(value)}
                          />
                        </linearGradient>
                      </defs>
                    </svg>
                    <div className="skorr">
                      <CircularProgressbarWithChildren
                        value={value}
                        maxValue={100}
                        circleRatio={0.78}
                        styles={buildStyles({
                          rotation: 0.61,
                          strokeLinecap: "round",
                          trailColor: "#e6f0e9",
                          textColor: "#1c1c1c",
                          pathTransitionDuration: 0.5,
                        })}
                      >
                        <div className="skills">
                          <div
                            style={{ textAlign: "center", lineHeight: "1.8vw" }}
                          >
                            <div
                              style={{
                                fontSize: "1.829vw",
                                fontWeight: "800",
                                color: "#253837",
                              }}
                            >
                              {scoreValue}
                            </div>
                            <div
                              style={{ fontSize: "0.854vw", color: "#7F7F7F" }}
                            >
                              /{maxValue}
                            </div>
                          </div>
                          <div className="skoreset">
                            <div
                              className="skorstart"
                              style={{
                                fontSize: "0.854vw",
                                fontWeight: "500",
                                color: "##7F7F7F",
                              }}
                            >
                              0
                            </div>
                            <div
                              style={{
                                fontSize: "0.854vw",
                                fontWeight: "500",
                                color: "##7F7F7F",
                              }}
                              className="skorend"
                            >
                              {maxValue}
                            </div>
                          </div>
                        </div>
                      </CircularProgressbarWithChildren>
                    </div>
                  </div>
                </div>

                <div className="col-6">
                  <div>
                    <p className="style1">{_t("scoreStatus")}:</p>
                    {returnSkorStatus()}
                  </div>
                  <div className="row mb-2 about-finical-skor">
                    <div className="col-6">
                      <p className="style1">{_t("createdOn")}:</p>
                      <p className="style2">
                        {moment(
                          haveValue(user?.bankVerificationDate)
                            ? user?.bankVerificationDate
                            : user?.created_at
                        ).format("DD-MM-YYYY")}
                      </p>
                    </div>
                    <div className="col-6">
                      <p className="style1">{_t("validTill")}:</p>
                      <p className="style2">
                        {moment(
                          haveValue(user?.bankVerificationDate)
                            ? user?.bankVerificationDate
                            : user?.created_at
                        )
                          .add(2, "months")
                          .format("DD-MM-YYYY")}
                      </p>
                    </div>
                  </div>
                  <div className="about-finical-skor">
                    <p className="style1">{_t("accountHolder")}:</p>
                    <p className="style2 fw-bold">
                      {haveValue(
                        user?.kyc_details?.userDataByProvider[0]?.accounts[0]
                          ?.holderName
                      )
                        ? user?.kyc_details?.userDataByProvider[0]?.accounts[0]
                            ?.holderName
                        : `${user?.fname} ${user?.lname}`}
                    </p>
                  </div>
                  <div className="bank-account-text-wrapper">
                    {user?.ie_verified &&
                    user?.is_university &&
                    !haveValue(user?.paymentScores?.creditScore?.value) ? (
                      <p className="style1">{_t("skorBasedOnIEProfile")} </p>
                    ) : (
                      <p className="style1">
                        {haveValue(
                          user?.kyc_details?.userDataByProvider?.[0]
                            ?.providerName
                        ) &&
                        user?.kyc_details?.userDataByProvider?.[0]
                          ?.providerName === "Uploaded from CSV"
                          ? _t("bankStatementUsedForScoring")
                          : _t("bankAccountUsedForScoring")}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="Profile_summary2 notAvailableSkor skorsetbox p-3 d-flex justify-content-center flex-column">
              <div className="bell-icon-wrapper">
                <img src={BellIcon} alt="Bell Icon" />
              </div>
              <p>
                {_t(
                  "thisTenantHaventdonetheirfinancialSkorYetYouCanSendRemainderToTheTenantToGetTheirSkorDone"
                )}
              </p>
              {showReportIcons && (
                <button className="send-reminder-button">
                  {_t("sendRemainder")}
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      <TotalSalaryModal
        isOpen={totalIncomeModal}
        onClose={() => setTotalIncomeModal(false)}
        handleUpdateSource={() => {
          setTotalIncomeModal(false);
          setUpdateIncomeSourceModal(true);
        }}
        user={user}
        effortObj={effortObj}
        userIncome={userIncome}
        gurantorsIncome={gurantorsIncome}
        setUpdateSourceObj={setUpdateSourceObj}
        showReportIcons={showReportIcons}
      />
      {updateIncomeSourceModal && (
        <UpdatedIncomeSourceModal
          show={updateIncomeSourceModal}
          onHide={() => {
            setUpdateIncomeSourceModal(false);
            setTotalIncomeModal(true);
          }}
          updateSourceObj={updateSourceObj}
          handleIncomeChange={handleIncomeChange}
        />
      )}
      {/* <DefaultCheckReportModal 

      /> */}
    </>
  );
};

export default DetailsSkor;
